import { observable, action } from 'mobx';

import { api } from '../services';

class LockbeatStore {
  @observable imeisWithLockbeat = [];

  @action loadImei = () => {
    api('getAllLockbeat').then(({ cars }) => {
      this.setLockbeat((cars || []).map(car => car.imei));
      return this.imeis;
    });
  };

  @action setLockbeat(imeisWithLockbeat) {
    this.imeisWithLockbeat = imeisWithLockbeat;
  }

  @action
  toggle(imei, lat, lon) {
    return api('updateLockbeat', imei, lat, lon, this.imeiHasNoLockbeat(imei)).then(() => this.loadImei());
  }

  imeiHasNoLockbeat(imei) {
    return this.imeisWithLockbeat.findIndex(imeiWithLockbeat => imeiWithLockbeat === imei) === -1;
  }
}

export default new LockbeatStore();



// WEBPACK FOOTER //
// ./src/stores/lockbeatStore.js